import { FieldType } from 'modules/domains';
import { BaseOption } from 'ui/selects';

import { isNumericField } from './isNumericField';

export const compareFieldFacetOptions = (
  a: BaseOption<string>,
  b: BaseOption<string>,
  fieldType?: FieldType,
) =>
  fieldType && isNumericField(fieldType)
    ? Number(a.value) - Number(b.value)
    : a.value.localeCompare(b.value);
